// WholesalerList.tsx
import React, { useEffect } from "react";
import { DataTable } from "../../../DataTable/DataTable";
import { Edit, Trash } from "lucide-react";
import { MarketerData } from "./types";
import toast from "react-hot-toast";
import { InverntroyService } from "../../../../services/api/inventroy.service";

interface MarketerListProps {
  searchTerm?: string;
  setSelectedMarketer: (data:MarketerData)=> void
  setShowMarketerModal: ()=> void
}

const MarketerList: React.FC<MarketerListProps> = ({ searchTerm,setSelectedMarketer,setShowMarketerModal }) => {
  const [isLoading, setIsLoading] = React.useState(false);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [pageSize, setPageSize] = React.useState(10);
  const [totalPages, setTotalPages] = React.useState(1);
  const [totalItemsCount, setTotalItemsCount] = React.useState(0);
  const [marketerData, setMarketerData] = React.useState<MarketerData[]>(
    []
  );

  const loadMarketerData = async (
    page: number,
    pageSize: number,
    searchTerm?: string
  ) => {
    try {
      setIsLoading(true);
      const response = await InverntroyService.getMarketerListing(
        page,
        pageSize,
        searchTerm
      );
      if (response.success) {
        setMarketerData(response.data);
      } else {
        toast.error(response.message);
        setMarketerData([]);
      }
      setTotalItemsCount(response.pagination.totalItemsCount);
      setTotalPages(response.pagination.totalPages);
    } catch (error) {
      toast.error(`${error}`);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadMarketerData(currentPage, pageSize, searchTerm);
  }, [currentPage, pageSize, searchTerm]);

  const handleDelteMarketer = async (id: string) => {
    try {
      const response = await InverntroyService.deleteMarketer(id);

      if (response.success) {
        toast.success(response.message);
        loadMarketerData(1, 10);
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      toast.error((error as Error)?.message || "An error occurred");
    }
  };
  const columns = [
    {
      key: "Logo",
      title: "Logo",
      width: "w-[100px]",
      render: (item: MarketerData) => (
        <div className="flex items-center justify-center">
          {item.marketer_logo ? (
            <div className="relative w-10 h-10 border rounded-full overflow-hidden">
              <img
                src={item.marketer_logo}
                alt={item.marketer_name}
                className="w-full h-full object-cover"
              />
            </div>
          ) : (
            <div className="w-10 h-10 bg-gray-200 border rounded-full flex items-center justify-center text-gray-500 text-xs">
              No Logo
            </div>
          )}
        </div>
      ),
    },
    {
      key: "Marketer Name",
      title: "Marketer Name",
      width: "w-[200px]",
      render: (item: MarketerData) => (
        <div
          className="flex items-center space-x-2 line-clamp-2 cursor-default"
          title={item.marketer_name}
        >
          {item.marketer_name || "N/A"}
        </div>
      ),
    },
    {
      key: "Address",
      title: "Address",
      width: "w-[250px]",
      render: (item: MarketerData) => (
        <div className="flex items-center space-x-2 line-clamp-2" title={item.marketer_address}>
          {item.marketer_address || "N/A"}
        </div>
      ),
    },
    {
      key: "Created At",
      title: "Created At",
      width: "w-[150px]",
      render: (item: MarketerData) => (
        <div className="flex items-center space-x-2">
          {item.created_at ? new Date(item.created_at).toISOString().split("T")[0] : "N/A"}
        </div>
      ),
    },
    {
      key: "Actions",
      title: "Actions",
      width: "w-[150px]",
      render: (item: MarketerData) => (
        <div className="flex space-x-4">
          <button
            className="text-yellow-500 hover:text-yellow-700"
            onClick={() => {
              setSelectedMarketer(item);
              setShowMarketerModal();
            }}
          >
            <Edit className="w-5 h-5" />
          </button>
          <button
            className="text-red-500 hover:text-red-700"
            onClick={() => {
              handleDelteMarketer(item.id);
            }}
          >
            <Trash className="w-5 h-5" />
          </button>
        </div>
      ),
    },
  ];

  return (
    <div>
      <DataTable
        data={marketerData}
        columns={columns}
        isLoading={isLoading}
        customFilters={[]}
        pagination={{
          currentPage,
          setCurrentPage,
          setTotalPages,
          totalPages,
          totalItemsCount,
          pageSize,
          setPageSize,
        }}
      />
    </div>
  );
};

export default MarketerList;
